angular.module('gym').factory('TrainersService', ["$rootScope", function($rootScope) {
  return {
    get: function() {
      return _.filter($rootScope.gym.users, {
        trainer: true
      });
    }
  };
}]);
